import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppRouter } from './AppRouter';
import { canLoadAppInsights, isE2eTestMode } from './config/appConfig';
import { appInsights } from './lib/appInsights';
import { initSW } from './lib/serviceWorkerHelpers';

import '~/common/schemas/_global';

initSW();

if (canLoadAppInsights) appInsights.loadAppInsights();

const root = createRoot(document.getElementById('app')!);

const router = <AppRouter />;

// Disable StrictMode in E2E test mode to avoid double rendering which can cause issues with tests
root.render(isE2eTestMode ? router : <StrictMode>{router}</StrictMode>);
